import { useMemo } from "react";
import { useProductDetails } from "../productContext/ProductProvider";
import styles from "./legalCopy.module.css";
import productStyles from "../productDetails.module.css";
import { useTranslation } from "react-i18next";
import { sanitizeWithAnchor } from "../../../utils/Utils";

function LegalCopy() {
	const { t } = useTranslation();
	const {
		productDetails: { legalCopy },
		lng,
	} = useProductDetails();

	const { legalCopyString } = useMemo(() => getLegalCopyData(legalCopy, lng), [legalCopy, lng]);

	return (
		<section className={`${productStyles.section} ${styles.legalCopy}`}>
			<div className={`${productStyles.title}`}>{t("Legal Copy")}</div>
			<div className={styles.legalCopy_sub_section}>
				<p  className="word-wrapper"
					dangerouslySetInnerHTML={{
						__html: sanitizeWithAnchor(legalCopyString),
					}}></p>
			</div>
		</section>
	);
}

LegalCopy.shouldRender = ({ productDetails: { legalCopy }, lng }) => {
	return getLegalCopyData(legalCopy, lng).isVisible;
};
export function getLegalCopyData(legalCopy, lng ) {
	if (!legalCopy)
		return {
			legalCopyString: "",
			isVisible: false,
		};

	const legalCopyString = legalCopy?.[lng] ?? legalCopy?.en_US ?? "";

	return {
		legalCopyString,
		isVisible: Boolean(legalCopyString),
	};
}
export default LegalCopy;
